import THEME from 'pobble-components/dist/theme'

const { COLORS } = THEME

export default {
  label: {
    color: COLORS.TEXT.DARK_GREY.NORMAL,
    display: 'flex',
    fontSize: '16px',
    lineHeight: '18px',
    margin: '0 0 8px',
    '&$small': {
      margin: '0 0 6px'
    }
  },
  spaceBetween: {
    justifyContent: 'space-between'
  },
  gapLeft: {
    margin: '0 0 0 8px',
    '&$small': {
      margin: '0 0 0 6px'
    }
  },
  gapRight: {
    margin: '0 8px 0 0',
    '&$small': {
      margin: '0 6px 0 0'
    }
  },
  small: {
    fontSize: '12px',
    lineHeight: '12px'
  },
  asterisk: {
    color: COLORS.RED.NORMAL,
    marginLeft: '.2em'
  }
}
